import { Controller } from "@hotwired/stimulus"

export default class ClassReplacementController extends Controller {
  static targets = ["element"]

  replace(event) {
    this.#toggleClasses(
      event.currentTarget,
      event.params.fromClasses,
      event.params.toClasses
    )
  }

  targetReplace(event) {
    if (this.hasElementTarget) {
      this.#toggleClasses(
        this.elementTarget,
        event.params.fromClasses,
        event.params.toClasses
      )
    }
  }

  #toggleClasses(target, fromClasses, toClasses) {
    fromClasses.forEach((className) => {
      target.classList.remove(className)
    })

    toClasses.forEach((className) => {
      target.classList.add(className)
    })
  }
}
